export default __webpack_public_path__ + "static/media/22-23-1.eedecd88.png";